import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-switch-1-6-0{display:block;position:relative;line-height:30px}.hcr-switch__input-1-6-0{position:absolute;opacity:0}.hcr-switch__label-1-6-0{display:block;position:relative;padding-right:57px;line-height:1.375em;cursor:pointer}.hcr-switch__label-1-6-0:before{right:0;width:45px;height:5px;border-radius:2.5px;background-color:#c8c8c8}.hcr-switch__label-1-6-0:after,.hcr-switch__label-1-6-0:before{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);-webkit-transition:-webkit-transform .4s;transition:-webkit-transform .4s;transition:transform .4s;transition:transform .4s,-webkit-transform .4s;content:\"\"}.hcr-switch__label-1-6-0:after{left:calc(100% - 45px);width:30px;height:30px;border:2px solid #e1e1e1;border-radius:100%;background-color:#fff}.hcr-switch__input-1-6-0:focus+.hcr-switch__label-1-6-0:after{outline:1px solid transparent;-webkit-box-shadow:0 0 3px #00b5e2;box-shadow:0 0 3px #00b5e2}.hcr-switch__input-1-6-0:checked+.hcr-switch__label-1-6-0:after{-webkit-transform:translateY(-50%) translateX(15px);transform:translateY(-50%) translateX(15px);border-color:#ffad00}.hcr-switch__input-1-6-0:checked+.hcr-switch__label-1-6-0:before{background-color:#ffad00}.hcr-switch--stacked-1-6-0 .hcr-switch__label-1-6-0{padding-bottom:36px;padding-left:0}.hcr-switch--stacked-1-6-0 .hcr-switch__label-1-6-0:after,.hcr-switch--stacked-1-6-0 .hcr-switch__label-1-6-0:before{top:calc(50% + 12px);bottom:0;left:0}@media (min-width:1200px){.hcr-switch--stacked-1-6-0 .hcr-switch__label-1-6-0{color:#757575}}.hcr-switch__input-1-6-0:disabled+.hcr-switch__label-1-6-0:before{background:#e1e1e1;opacity:.5}.hcr-switch__input-1-6-0:disabled+.hcr-switch__label-1-6-0:after{border-color:hsla(0,0%,88.2%,.5)}.hcr-switch__input-1-6-0:disabled+.hcr-switch__label-1-6-0:after,.hcr-switch__input-1-6-0:disabled+.hcr-switch__label-1-6-0:before{cursor:not-allowed}@media (min-width:600px){.hcr-switch-1-6-0{display:inline-block}.hcr-switch__label-1-6-0{padding-right:0;padding-left:57px}.hcr-switch__label-1-6-0:before{right:auto;left:0}.hcr-switch__label-1-6-0:after{left:0}}",
map:{"hcr-switch":"hcr-switch-1-6-0","hcr-switch__input":"hcr-switch__input-1-6-0","hcr-switch__label":"hcr-switch__label-1-6-0","hcr-switch--stacked":"hcr-switch--stacked-1-6-0"}};

var bem = Bem('switch', styles);
var Switch = function Switch(_ref) {
  var id = _ref.id,
      label = _ref.label,
      extraClasses = _ref.extraClasses,
      stacked = _ref.stacked,
      rest = _objectWithoutProperties(_ref, ["id", "label", "extraClasses", "stacked"]);

  return React.createElement("label", {
    htmlFor: id,
    className: bem.b({
      stacked: stacked
    }, extraClasses)
  }, React.createElement("input", _extends({
    id: id,
    className: "".concat(bem.e('input')),
    type: "checkbox"
  }, rest)), React.createElement("div", {
    className: "".concat(bem.e('label'))
  }, label));
};
Switch.displayName = 'Switch';
Switch.defaultProps = {
  extraClasses: '',
  stacked: false
};
Switch.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Provides label text, required if aria-label is not passed */

  /* eslint-disable react/require-default-props */
  // we want label to be always checked against
  label: function label(_ref2) {
    var ariaLabel = _ref2['aria-label'],
        _label = _ref2.label;
    // if no aria label nor label throw validation error
    return !ariaLabel && !_label ? new Error('Either label or aria label are required') : null;
  },

  /** display as stacked */
  stacked: PropTypes.bool,

  /** Id for the switch checkbox */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
var _switch = Injecss(Switch, styles);

export { _switch as Switch };
